module.exports = __webpack_public_path__ + "img/timg.4c12900c.jpg";